"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var fabric_1 = require("fabric");
var lodash_1 = require("lodash");
var nanoid_1 = require("nanoid");
var Base_1 = __importDefault(require("./Base"));
var constants_1 = require("../common/constants");
var object_importer_1 = __importDefault(require("../utils/object-importer"));
var fabric_2 = __importStar(require("../utils/fabric"));
var image_loader_1 = require("../utils/image-loader");
var Objects = /** @class */ (function (_super) {
    __extends(Objects, _super);
    function Objects() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.add = function (item) { return __awaiter(_this, void 0, void 0, function () {
            var canvas, options, objectImporter, refItem, object, frame, isBackgroundImage, currentBackgrounImage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        canvas = this.canvas;
                        options = this.editor.frame.options;
                        objectImporter = new object_importer_1.default(this.editor);
                        refItem = item;
                        return [4 /*yield*/, objectImporter.import(refItem, options)];
                    case 1:
                        object = _a.sent();
                        if (this.config.clipToFrame) {
                            frame = this.editor.frame.frame;
                            object.clipPath = frame;
                        }
                        isBackgroundImage = refItem.type === constants_1.LayerType.BACKGROUND_IMAGE;
                        if (!isBackgroundImage) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.unsetBackgroundImage()];
                    case 2:
                        currentBackgrounImage = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (isBackgroundImage) {
                            canvas.add(object);
                            object.moveTo(2);
                            this.scale("fill", object.id);
                            if (currentBackgrounImage) {
                                canvas.add(currentBackgrounImage);
                                this.sendToBack(currentBackgrounImage.id);
                            }
                        }
                        else {
                            canvas.add(object);
                            object.center();
                        }
                        this.state.setActiveObject(object);
                        canvas.setActiveObject(object);
                        this.updateContextObjects();
                        this.editor.history.save();
                        if (object.type === "StaticVideo") {
                            setTimeout(function () {
                                _this.canvas.requestRenderAll();
                            }, 500);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         *
         * @param options object properties to be updated
         * @param id if provided, will update the update by id
         */
        _this.update = function (options, id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            var canvas = _this.canvas;
            if (refObject) {
                var _loop_1 = function (property) {
                    if (property === "angle" || property === "top" || property === "left") {
                        if (property === "angle") {
                            // @ts-ignore
                            refObject.rotate(options["angle"]);
                            canvas.requestRenderAll();
                        }
                        else {
                            // @ts-ignore
                            refObject.set(property, frame[property] + options[property]);
                            canvas.requestRenderAll();
                        }
                    }
                    else if (property === "clipToFrame") {
                        if (options["clipToFrame"]) {
                            refObject.set("clipPath", frame);
                        }
                        else {
                            refObject.set("clipPath", null);
                        }
                    }
                    else if (property === "shadow") {
                        // @ts-ignore
                        _this.setShadow(options["shadow"]);
                    }
                    else if (property === "metadata") {
                        refObject.set("metadata", __assign(__assign({}, refObject.metadata), options[property]));
                    }
                    else if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION && refObject._objects) {
                        refObject._objects.forEach(function (object) {
                            if (property === "metadata") {
                                object.set("metadata", __assign(__assign({}, object.metadata), options["metadata"]));
                            }
                            else {
                                // @ts-ignore
                                object.set(property, options[property]);
                            }
                            object.setCoords();
                        });
                    }
                    else {
                        // @ts-ignore
                        refObject.set(property, options[property]);
                        canvas.requestRenderAll();
                        refObject.setCoords();
                    }
                };
                for (var property in options) {
                    _loop_1(property);
                }
                _this.editor.history.save();
            }
        };
        _this.clear = function () {
            var frame = _this.editor.frame.frame;
            _this.canvas.getObjects().forEach(function (object) {
                if (object.type !== constants_1.LayerType.FRAME) {
                    _this.canvas.remove(object);
                }
            });
            frame.set({
                fill: "#ffffff",
            });
            _this.canvas.renderAll();
        };
        _this.get = function (id) {
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            return refObject;
        };
        _this.reset = function () {
            var background = _this.editor.frame.background;
            _this.canvas.getObjects().forEach(function (object) {
                if (object.type !== constants_1.LayerType.FRAME && object.type !== constants_1.LayerType.BACKGROUND) {
                    _this.canvas.remove(object);
                }
            });
            background === null || background === void 0 ? void 0 : background.set({
                fill: "#ffffff",
            });
            _this.canvas.renderAll();
            _this.editor.history.reset();
        };
        _this.select = function (id) {
            _this.canvas.discardActiveObject();
            if (id) {
                var _a = __read(_this.findById(id), 1), object = _a[0];
                if (object) {
                    _this.canvas.disableEvents();
                    _this.canvas.setActiveObject(object);
                    if (object.group) {
                        object.hasControls = false;
                    }
                    _this.canvas.enableEvents();
                    _this.canvas.requestRenderAll();
                    var activeObject = _this.canvas.getActiveObject();
                    _this.state.setActiveObject(activeObject);
                }
            }
            else {
                var filteredObjects = _this.canvas.getObjects().filter(function (object) {
                    if (object.type === constants_1.LayerType.FRAME || object.type === constants_1.LayerType.BACKGROUND) {
                        return false;
                    }
                    else if (!object.evented) {
                        return false;
                    }
                    else if (object.locked) {
                        return false;
                    }
                    return true;
                });
                if (!filteredObjects.length) {
                    return;
                }
                if (filteredObjects.length === 1) {
                    _this.canvas.setActiveObject(filteredObjects[0]);
                    _this.canvas.renderAll();
                    _this.state.setActiveObject(filteredObjects[0]);
                    return;
                }
                var activeSelection = new fabric_1.fabric.ActiveSelection(filteredObjects, {
                    canvas: _this.canvas,
                });
                _this.canvas.setActiveObject(activeSelection);
                _this.canvas.renderAll();
                _this.state.setActiveObject(activeSelection);
            }
        };
        _this.deselect = function () {
            _this.canvas.discardActiveObject();
            _this.canvas.requestRenderAll();
            _this.state.setActiveObject(null);
        };
        _this.cut = function () {
            _this.copy();
            _this.isCut = true;
            _this.remove();
        };
        _this.copy = function () {
            var activeObject = _this.canvas.getActiveObject();
            if (activeObject) {
                _this.clipboard = activeObject;
            }
        };
        _this.copyById = function (id) {
            var object = _this.findOneById(id);
            if (object) {
                _this.clipboard = object;
            }
        };
        _this.clone = function () {
            if (_this.canvas) {
                var activeObject = _this.canvas.getActiveObject();
                var frame = _this.editor.frame.frame;
                _this.canvas.discardActiveObject();
                _this.duplicate(activeObject, frame, function (duplicates) {
                    var selection = new fabric_1.fabric.ActiveSelection(duplicates, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.canvas.requestRenderAll();
                });
            }
        };
        _this.cloneAudio = function (id) {
            var object = _this.findOneById(id);
            var frame = _this.editor.frame.frame;
            _this.deselect();
            _this.duplicate(object, frame, function (duplicates) {
                _this.canvas.requestRenderAll();
                _this.updateContextObjects();
            });
        };
        _this.paste = function () {
            var object = _this.clipboard;
            if (object) {
                var frame = _this.editor.frame.frame;
                _this.canvas.discardActiveObject();
                _this.duplicate(object, frame, function (duplicates) {
                    var selection = new fabric_1.fabric.ActiveSelection(duplicates, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.canvas.requestRenderAll();
                    _this.updateContextObjects();
                });
            }
        };
        /**`
         * Remove active object
         */
        _this.remove = function (id) {
            var refObject = _this.canvas.getActiveObjects();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if ((0, lodash_1.isArray)(refObject)) {
                refObject.forEach(function (obj) {
                    _this.canvas.remove(obj);
                });
            }
            else {
                _this.canvas.remove(refObject);
            }
            _this.canvas.discardActiveObject().renderAll();
            _this.editor.history.save();
            _this.updateContextObjects();
        };
        _this.list = function () {
            var objects = _this.canvas.getObjects();
            var filteredObjects = objects.filter(function (o) {
                return o.type !== constants_1.LayerType.FRAME && o.type !== constants_1.LayerType.BACKGROUND;
            });
            return filteredObjects;
        };
        _this.copyStyle = function () {
            var activeObject = _this.canvas.getActiveObject();
            if (activeObject) {
                //  @ts-ignore
                var clonableProps = constants_1.copyStyleProps[activeObject.type];
                var clonedProps = (0, lodash_1.pick)(activeObject.toJSON(), clonableProps);
                _this.copyStyleClipboard = {
                    objectType: activeObject.type,
                    props: clonedProps,
                };
                _this.editor.frame.setHoverCursor((0, constants_1.getCopyStyleCursor)());
                _this.canvas.hoverCursor = (0, constants_1.getCopyStyleCursor)();
                _this.canvas.defaultCursor = (0, constants_1.getCopyStyleCursor)();
            }
        };
        _this.pasteStyle = function () {
            var activeObject = _this.canvas.getActiveObject();
            if (activeObject && _this.copyStyleClipboard) {
                if (activeObject.type === _this.copyStyleClipboard.objectType) {
                    var _a = _this.copyStyleClipboard.props, fill = _a.fill, basicProps = __rest(_a, ["fill"]);
                    activeObject.set(basicProps);
                    if (fill) {
                        if (fill.type) {
                            activeObject.set({ fill: new fabric_1.fabric.Gradient(fill) });
                        }
                        else {
                            activeObject.set({ fill: fill });
                        }
                    }
                }
            }
            _this.copyStyleClipboard = null;
            _this.editor.frame.setHoverCursor("default");
            _this.canvas.hoverCursor = "move";
            _this.canvas.defaultCursor = "default";
        };
        /**
         * Moves an object or a selection up in stack of drawn objects.
         */
        _this.bringForward = function (id) {
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                _this.canvas.bringForward(refObject);
            }
        };
        _this.bringForwardById = function (id) {
            _this.canvas.getObjects().forEach(function (o) {
                if (o.id === id) {
                    _this.canvas.bringForward(o);
                }
            });
        };
        /**
         * Moves an object or the objects of a multiple selection to the top of the stack of drawn objects
         */
        _this.bringToFront = function (id) {
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                _this.canvas.bringToFront(refObject);
            }
        };
        /**
         * Moves an object or a selection down in stack of drawn objects.
         */
        _this.sendBackwards = function (id) {
            var objects = _this.canvas.getObjects();
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            var index = objects.findIndex(function (o) { return o === refObject; });
            var backgroundImage = objects.find(function (o) { return o.type === constants_1.LayerType.BACKGROUND_IMAGE; });
            var canBeMoved = backgroundImage ? index > 3 : index > 2;
            if (refObject && canBeMoved) {
                _this.canvas.sendBackwards(refObject);
            }
        };
        /**
         * Moves an object to specified level in stack of drawn objects.
         */
        _this.sendToBack = function (id) {
            var refObject = _this.canvas.getActiveObject();
            var objects = _this.canvas.getObjects();
            var backgroundImage = objects.find(function (o) { return o.type === constants_1.LayerType.BACKGROUND_IMAGE; });
            if (id) {
                refObject = _this.findOneById(id);
            }
            // const indexx =
            if (refObject) {
                if (backgroundImage) {
                    refObject.moveTo(3);
                }
                else {
                    refObject.moveTo(2);
                }
            }
        };
        /**
         * Moves an object to the top of the frame. If multiple objects are selected,
         * will move all objects to the top of the selection.
         */
        _this.alignTop = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refTop_1 = refObject.top;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        currentObject.set({
                            top: refTop_1,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    currentObject.set({
                        top: frame.top,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Moves an object to the middle of the frame. If multiple objects are selected,
         * will move all objects to the middle of the selection.
         */
        _this.alignMiddle = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refTop_2 = refObject.top;
                    var refHeight_1 = refObject.height;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        var currentObjectHeight = currentObject.getScaledHeight();
                        currentObject.set({
                            top: refTop_2 + refHeight_1 / 2 - currentObjectHeight / 2,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    var currentObjectHeight = currentObject.getScaledHeight();
                    currentObject.set({
                        top: frame.top + frame.height / 2 - currentObjectHeight / 2,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Moves an object to the bottom of the frame. If multiple objects are selected,
         * will move all objects to the bottom of the selection.
         */
        _this.alignBottom = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refTop_3 = refObject.top;
                    var refHeight_2 = refObject.height;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        var currentObjectHeight = currentObject.getScaledHeight();
                        currentObject.set({
                            top: refTop_3 + refHeight_2 - currentObjectHeight,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    var currentObjectHeight = currentObject.getScaledHeight();
                    currentObject.set({
                        top: frame.top + frame.height - currentObjectHeight,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Moves an object to the left of the frame. If multiple objects are selected,
         * will move all objects to the left of the selection.
         */
        _this.alignLeft = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refLeft_1 = refObject.left;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        currentObject.set({
                            left: refLeft_1,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    currentObject.set({
                        left: frame.left,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Moves an object to the center of the frame. If multiple objects are selected,
         * will move all objects to the center of the selection.
         */
        _this.alignCenter = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refLeft_2 = refObject.left;
                    var refWidth_1 = refObject.width;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        var currentObjectWidth = currentObject.getScaledWidth();
                        currentObject.set({
                            left: refLeft_2 + refWidth_1 / 2 - currentObjectWidth / 2,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    var currentObjectWidth = currentObject.getScaledWidth();
                    currentObject.set({
                        left: frame.left + frame.width / 2 - currentObjectWidth / 2,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Moves an object to the right of the frame. If multiple objects are selected,
         * will move all objects to the right of the selection.
         */
        _this.alignRight = function (id) {
            var frame = _this.editor.frame.frame;
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject.type === constants_1.LayerType.ACTIVE_SELECTION) {
                    var selectedObjects = refObject._objects;
                    var refLeft_3 = refObject.left;
                    var refWidth_2 = refObject.width;
                    _this.canvas.discardActiveObject();
                    selectedObjects.forEach(function (object) {
                        var currentObject = object;
                        var currentObjectWidth = currentObject.getScaledWidth();
                        currentObject.set({
                            left: refLeft_3 + refWidth_2 - currentObjectWidth,
                        });
                    });
                    var selection = new fabric_1.fabric.ActiveSelection(selectedObjects, {
                        canvas: _this.canvas,
                    });
                    _this.canvas.setActiveObject(selection);
                    _this.state.setActiveObject(selection);
                }
                else {
                    var currentObject = refObject;
                    var currentObjectWidth = currentObject.getScaledWidth();
                    currentObject.set({
                        left: frame.left + frame.width - currentObjectWidth,
                    });
                }
                _this.canvas.requestRenderAll();
            }
        };
        /**
         * Set object shadow
         * @param options ShadowOptions
         */
        _this.setShadow = function (options) {
            var activeObject = _this.canvas.getActiveObject();
            if (activeObject instanceof fabric_1.fabric.Group && activeObject.type !== constants_1.LayerType.STATIC_VECTOR) {
                // @ts-ignore
                activeObject._objects.forEach(function (object) {
                    (0, fabric_2.setObjectShadow)(object, options);
                });
            }
            else {
                (0, fabric_2.setObjectShadow)(activeObject, options);
            }
            _this.canvas.requestRenderAll();
            _this.editor.history.save();
        };
        /**
         * Set object fill as gradient
         * @param param GradientOptions
         */
        _this.setGradient = function (_a) {
            var angle = _a.angle, colors = _a.colors;
            var activeObject = _this.canvas.getActiveObject();
            if (activeObject instanceof fabric_1.fabric.Group) {
                // @ts-ignore
                activeObject._objects.forEach(function (object) {
                    (0, fabric_2.default)(object, angle, colors);
                });
            }
            else {
                (0, fabric_2.default)(activeObject, angle, colors);
            }
            _this.canvas.requestRenderAll();
            _this.editor.history.save();
        };
        /**
         * Group selected objects
         */
        _this.group = function () {
            var activeObject = _this.canvas.getActiveObject();
            if (!activeObject) {
                return;
            }
            if (activeObject.type !== constants_1.LayerType.ACTIVE_SELECTION) {
                return;
            }
            activeObject.toGroup();
            _this.canvas.requestRenderAll();
            _this.editor.history.save();
            var groupedActiveObject = _this.canvas.getActiveObject();
            groupedActiveObject.set({
                name: "group",
                id: (0, nanoid_1.nanoid)(),
                // @ts-ignore
                subTargetCheck: true,
            });
            _this.updateContextObjects();
        };
        _this.ungroup = function () {
            var frame = _this.editor.frame.frame;
            var activeObject = _this.canvas.getActiveObject();
            if (!activeObject) {
                return;
            }
            if (activeObject.type !== constants_1.LayerType.GROUP.toLowerCase()) {
                return;
            }
            activeObject.clipPath = null;
            var activeSelection = activeObject.toActiveSelection();
            // @ts-ignore
            activeSelection._objects.forEach(function (object) {
                object.clipPath = frame;
            });
            _this.state.setActiveObject(activeSelection);
            _this.canvas.requestRenderAll();
            _this.editor.history.save();
            _this.updateContextObjects();
        };
        /**
         * Lock object movement and disable controls
         */
        _this.lock = function (id) {
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject._objects) {
                    refObject._objects.forEach(function (object) {
                        object.set({
                            hasControls: false,
                            lockMovementY: true,
                            lockMovementX: true,
                            locked: true,
                        });
                    });
                    // @ts-ignore
                    refObject.set({
                        hasControls: false,
                        lockMovementY: true,
                        lockMovementX: true,
                        locked: true,
                    });
                }
                else {
                    // @ts-ignore
                    refObject.set({
                        hasControls: false,
                        lockMovementY: true,
                        lockMovementX: true,
                        locked: true,
                    });
                }
                _this.canvas.requestRenderAll();
                _this.editor.history.save();
            }
        };
        /**
         * Unlock active object
         */
        _this.unlock = function (id) {
            var refObject = _this.canvas.getActiveObject();
            if (id) {
                refObject = _this.findOneById(id);
            }
            if (refObject) {
                if (refObject === null || refObject === void 0 ? void 0 : refObject._objects) {
                    refObject._objects.forEach(function (object) {
                        object.set({
                            hasControls: true,
                            lockMovementY: false,
                            lockMovementX: false,
                            locked: false,
                        });
                    });
                    // @ts-ignore
                    refObject.set({
                        hasControls: true,
                        lockMovementY: false,
                        lockMovementX: false,
                        locked: false,
                    });
                }
                else {
                    // @ts-ignore
                    refObject.set({
                        hasControls: true,
                        lockMovementY: false,
                        lockMovementX: false,
                        locked: false,
                    });
                }
                _this.canvas.requestRenderAll();
                _this.editor.history.save();
            }
        };
        _this.findByName = function (name) {
            return _this.canvas.getObjects().filter(function (o) { return o.name === name; });
        };
        _this.removeByName = function (name) {
            _this.canvas.getObjects().forEach(function (o) {
                if (o.name === name) {
                    _this.canvas.remove(o);
                    _this.editor.history.save();
                }
            });
            _this.canvas.requestRenderAll();
        };
        _this.findByIdInObjecs = function (id, objects) {
            var e_1, _a;
            var item = null;
            try {
                for (var objects_1 = __values(objects), objects_1_1 = objects_1.next(); !objects_1_1.done; objects_1_1 = objects_1.next()) {
                    var object = objects_1_1.value;
                    if (object.id === id) {
                        item = object;
                        break;
                    }
                    if (object.type === "group") {
                        // @ts-ignore
                        var itemInGroup = _this.findByIdInObjecs(id, object._objects);
                        if (itemInGroup) {
                            item = itemInGroup;
                            break;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (objects_1_1 && !objects_1_1.done && (_a = objects_1.return)) _a.call(objects_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return item;
        };
        _this.findById = function (id) {
            var objects = _this.canvas.getObjects();
            var object = _this.findByIdInObjecs(id, objects);
            return [object];
        };
        _this.findOneById = function (id) {
            var objects = _this.findById(id);
            return objects[0];
        };
        _this.removeById = function (id) {
            _this.canvas.getObjects().forEach(function (o) {
                if (o.id === id) {
                    _this.canvas.remove(o);
                    _this.editor.history.save();
                    _this.updateContextObjects();
                }
            });
            _this.canvas.requestRenderAll();
        };
        _this.updateContextObjects = function () {
            var objects = _this.canvas.getObjects();
            var filteredObjects = objects.filter(function (o) {
                return o.type !== "Frame" && o.type !== "Background";
            });
            _this.state.setObjects(filteredObjects);
        };
        return _this;
    }
    Objects.prototype.move = function (direction, value, id) {
        var refObject = this.canvas.getActiveObject();
        if (id) {
            refObject = this.findOneById(id);
        }
        if (refObject) {
            var updatedPosition = refObject[direction] + value;
            refObject.set(direction, updatedPosition);
            this.editor.history.save();
        }
    };
    Objects.prototype.position = function (position, value, id) {
        var refObject = this.canvas.getActiveObject();
        if (id) {
            refObject = this.findOneById(id);
        }
        if (refObject) {
            refObject.set(position, value);
            this.editor.history.save();
        }
    };
    Objects.prototype.resize = function (size, value, id) {
        var refObject = this.canvas.getActiveObject();
        if (id) {
            refObject = this.findOneById(id);
        }
        if (size === "width") {
            refObject.set("scaleX", value / refObject.width);
        }
        if (size === "height") {
            refObject.set("scaleY", value / refObject.height);
        }
    };
    Objects.prototype.scale = function (type, id) {
        var refObject = this.canvas.getActiveObject();
        var _a = this.editor.frame.frame, width = _a.width, height = _a.height, top = _a.top;
        if (id) {
            refObject = this.findOneById(id);
        }
        if (refObject) {
            var scaleX = width / refObject.width;
            var scaleY = height / refObject.height;
            var scaleMax = Math.max(scaleX, scaleY);
            var scaleMin = Math.min(scaleX, scaleY);
            if (type === "fit") {
                refObject.set({
                    scaleX: scaleMin,
                    scaleY: scaleMin,
                });
            }
            if (type === "fill") {
                refObject.set({
                    scaleY: scaleMax,
                    scaleX: scaleMax,
                });
            }
            refObject.center();
            if (scaleY >= scaleX) {
                refObject.set("top", top);
            }
        }
    };
    Objects.prototype.duplicate = function (object, frame, callback) {
        var _this = this;
        if (object instanceof fabric_1.fabric.Group && object.type !== constants_1.LayerType.STATIC_VECTOR) {
            var objects_2 = object.getObjects();
            var duplicates_1 = [];
            var _loop_2 = function (i) {
                this_1.duplicate(objects_2[i], frame, function (clones) {
                    duplicates_1.push.apply(duplicates_1, __spreadArray([], __read(clones), false));
                    if (i === objects_2.length - 1) {
                        callback(duplicates_1);
                    }
                });
            };
            var this_1 = this;
            for (var i = 0; i < objects_2.length; i++) {
                _loop_2(i);
            }
        }
        else {
            object.clone(function (clone) {
                clone.clipPath = undefined;
                clone.id = (0, nanoid_1.nanoid)();
                clone.set({
                    left: object.left + 10,
                    top: object.top + 10,
                });
                if (_this.config.clipToFrame) {
                    var frame_1 = _this.editor.frame.frame;
                    clone.clipPath = frame_1;
                }
                _this.canvas.add(clone);
                callback([clone]);
            }, ["keyValues", "src", "metadata"]);
        }
    };
    Objects.prototype.unsetBackgroundImage = function () {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var objects, currentBackgroundImage, nextImage, currentBackgroundImageJSON, nextImageElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objects = this.canvas.getObjects();
                        currentBackgroundImage = objects.find(function (o) { return o.type === constants_1.LayerType.BACKGROUND_IMAGE; });
                        if (!currentBackgroundImage) return [3 /*break*/, 2];
                        currentBackgroundImageJSON = currentBackgroundImage.toJSON(this.config.propertiesToInclude);
                        currentBackgroundImageJSON === null || currentBackgroundImageJSON === void 0 ? true : delete currentBackgroundImageJSON.clipPath;
                        return [4 /*yield*/, (0, image_loader_1.loadImageFromURL)(currentBackgroundImageJSON.src)];
                    case 1:
                        nextImageElement = _a.sent();
                        nextImage = new fabric_1.fabric.StaticImage(nextImageElement, __assign(__assign({}, currentBackgroundImageJSON), { id: (0, nanoid_1.nanoid)() }));
                        // @ts-ignore
                        // this.canvas.add(nextImage)
                        this.canvas.remove(currentBackgroundImage);
                        resolve(nextImage);
                        return [3 /*break*/, 3];
                    case 2:
                        resolve(null);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    Objects.prototype.setAsBackgroundImage = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var refObject, frame, nextImage, objectJSON, image, backgroundImage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refObject = this.canvas.getActiveObject();
                        if (id) {
                            refObject = this.findOneById(id);
                        }
                        if (!(refObject && refObject.type === constants_1.LayerType.STATIC_IMAGE)) return [3 /*break*/, 3];
                        frame = this.editor.frame.frame;
                        return [4 /*yield*/, this.unsetBackgroundImage()];
                    case 1:
                        nextImage = _a.sent();
                        if (nextImage) {
                            // @ts-ignore
                            this.canvas.add(nextImage);
                        }
                        objectJSON = refObject.toJSON(this.config.propertiesToInclude);
                        // @ts-ignore
                        delete objectJSON.clipPath;
                        return [4 /*yield*/, (0, image_loader_1.loadImageFromURL)(objectJSON.src)];
                    case 2:
                        image = _a.sent();
                        backgroundImage = new fabric_1.fabric.BackgroundImage(image, __assign(__assign({}, objectJSON), { id: (0, nanoid_1.nanoid)() }));
                        // @ts-ignore
                        this.canvas.add(backgroundImage);
                        backgroundImage.clipPath = frame;
                        this.canvas.remove(refObject);
                        this.canvas.requestRenderAll();
                        this.scale("fill", backgroundImage.id);
                        backgroundImage.moveTo(2);
                        if (nextImage) {
                            this.sendToBack(nextImage.id);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Text exclusive hooks
    Objects.prototype.toUppercase = function (id) {
        var refObject = this.canvas.getActiveObject();
        if (id) {
            refObject = this.findOneById(id);
        }
        if (refObject && refObject.type === constants_1.LayerType.STATIC_TEXT) {
            if (refObject.isEditing) {
                refObject.hiddenTextarea.value = refObject.hiddenTextarea.value.toUpperCase();
                refObject.updateFromTextArea();
                this.canvas.requestRenderAll();
                return;
            }
            var text = refObject.text;
            refObject.text = text.toUpperCase();
            this.canvas.requestRenderAll();
        }
    };
    // Text exclusive hooks
    Objects.prototype.toLowerCase = function (id) {
        var refObject = this.canvas.getActiveObject();
        if (id) {
            refObject = this.findOneById(id);
        }
        if (refObject && refObject.type === constants_1.LayerType.STATIC_TEXT) {
            if (refObject.isEditing) {
                refObject.hiddenTextarea.value = refObject.hiddenTextarea.value.toLowerCase();
                refObject.updateFromTextArea();
                this.canvas.requestRenderAll();
                return;
            }
            var text = refObject.text;
            refObject.text = text.toLowerCase();
            this.canvas.requestRenderAll();
        }
    };
    return Objects;
}(Base_1.default));
exports.default = Objects;
//# sourceMappingURL=Objects.js.map